import React from 'react';
import { volumes } from '../data/soklar';

// Neutral placeholders drawn with CSS while the SO KLAR image slots in data/soklar.ts are empty.
export function ProductBoxPlaceholder({
  className = ''
}: {
  className?: string;
}) {
  return <div role="img" aria-label="SO KLAR™ – 6 digitala volymer för åk 1–9" className={`relative mx-auto w-full max-w-sm ${className}`} data-id="element-263" data-mp="1esxxmzkqadtq">
      <div className="rounded-2xl bg-[#1B2A5E] p-5 text-white shadow-2xl shadow-slate-900/30" data-id="element-264" data-mp="19tl98ae7kyp1">
        <p className="text-xs font-semibold uppercase tracking-widest text-white/70" data-id="element-265" data-mp="15rhoev5nghr3">Åk 1–9 · Lgr22</p>
        <p className="mt-1 font-serif text-4xl leading-none tracking-tight" data-id="element-266" data-mp="10x3vr0idgoq4">SO KLAR<span className="align-super text-[0.45em]" data-id="element-267" data-mp="vvwpj5vvnxlk">™</span></p>
        <p className="mt-2 text-sm leading-snug text-white/80" data-id="element-268" data-mp="qxd02vi2s3og">Geografi · Historia · Religionskunskap · Samhällskunskap</p>
        <div className="mt-5 grid grid-cols-6 gap-1.5" data-id="element-269" data-mp="2q95seetx4kuu">
          {volumes.map(v => <div key={v.number} className={`flex h-36 flex-col justify-between rounded-md border-r-4 border-black/10 p-1.5 ${v.spine}`} data-id="element-270" data-mp="2laclx6d1tu46">
              <span className="text-[9px] font-bold opacity-80" data-id="element-271" data-mp="2t534uwhszj0x">{v.number.replace('Volym ', 'V')}</span>
              <span className="origin-bottom-left -rotate-90 translate-x-3 whitespace-nowrap text-[10px] font-semibold" data-id="element-272" data-mp="2y3eaev12f7dc">{v.level}</span>
            </div>)}
        </div>
        <p className="mt-4 text-center text-sm font-semibold text-[#FFC83D]" data-id="element-273" data-mp="2o82vablqvy52">6 volymer + 5 bonusar</p>
      </div>
    </div>;
}
export function PagePlaceholder({
  label,
  title
}: {
  label: string;
  title: string;
}) {
  return <div className="flex h-full w-full flex-col bg-white" aria-hidden="true" data-id="element-274" data-mp="3gvffif4fntv7">
      <div className="flex items-center justify-between bg-[#1B2A5E] px-4 py-3 text-white" data-id="element-275" data-mp="32614z3p4f6e8">
        <span className="text-[11px] font-bold uppercase tracking-widest" data-id="element-276" data-mp="37543046ooccp">SO KLAR™</span>
        <span className="flex h-6 w-6 items-center justify-center rounded-full bg-[#FF8A7A] text-[10px] font-bold text-[#1B2A5E]" data-id="element-277" data-mp="3uvhw7y108h8v">1</span>
      </div>
      <div className="flex flex-1 flex-col gap-3 p-5" data-id="element-278" data-mp="3j5dlduaei4r">
        <p className="text-[11px] font-bold uppercase tracking-widest text-[#2BB673]" data-id="element-279" data-mp="ddaw08qn7i1l">{label}</p>
        <p className="font-serif text-xl leading-tight text-slate-900" data-id="element-280" data-mp="8dpzs62uxnsk">{title}</p>
        {[0, 1, 2, 3, 4, 5, 6].map(i => <div key={i} className="h-2.5 rounded-full bg-slate-900/10" style={{
        width: `${92 - i * 7}%`
      }} data-id="element-281" data-mp="4b1o7qmre2rw" />)}
        <div className="mt-auto grid grid-cols-3 gap-2" data-id="element-282" data-mp="3vi5ugjb2xkz9">
          <div className="h-14 rounded-md bg-[#3FA9F5]/20" data-id="element-283" data-mp="3qk4brzhkfnob" />
          <div className="h-14 rounded-md bg-[#FFC83D]/30" data-id="element-284" data-mp="3qlns1q381yq3" />
          <div className="h-14 rounded-md bg-[#FF8A7A]/25" data-id="element-285" data-mp="3lrtaotb39vu6" />
        </div>
      </div>
    </div>;
}